module.exports = __webpack_public_path__ + "static/media/6.e9eaa778.png";